import { Vue, Options } from 'vue-class-component';
import { SET_APP_LOADING } from '../../../core/store/action-types';
import AuthService from '@/core/services/auth.service';
@Options({
  name: 'LoggedOut',
})
export default class LoggedOut extends Vue {
  isAuthenticated: boolean = false;

  async created() {
    this.isAuthenticated = !!AuthService.getAccount();
    // in case we've just performed the logout,
    // the account is undefined, but in case
    // we're coming back from the login form,
    // we should have the account valorized, and therefore
    // we can safely redirect the user to the app entry point.
    if (this.isAuthenticated) {
      // fake some waiting time to give some feedback to the user
      this.$store.dispatch(SET_APP_LOADING, true);
      setTimeout(async () => {
        this.$store.dispatch(SET_APP_LOADING, false);
        this.$router.replace({ path: '/', replace: true });
      }, 1000);
    }
  }

  async onGoToLoginClick() {
    this.$store.dispatch(SET_APP_LOADING, true);
    await new Promise((r) => {
      AuthService.handleRedirectPromise();
      // fake some waiting time to give some feedback to the user
      setTimeout(async () => {
        this.$store.dispatch(SET_APP_LOADING, false);
      }, 1000);
    });
  }
}
